import PropTypes from 'prop-types';

function MMHouseholdInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11321)">
                <path
                    d="M12.8188 14.2855C13.7216 13.7797 16.2293 12.6136 16.2293 12.6136C16.3496 12.5543 16.4885 12.5453 16.6155 12.5884C16.7425 12.6315 16.8471 12.7232 16.9064 12.8435L17.408 13.8508C17.4674 13.9717 17.4766 14.1112 17.4336 14.2388C17.3905 14.3665 17.2987 14.4719 17.1781 14.5321C17.1781 14.5321 15.1343 15.648 13.7634 16.2624L12.8188 14.2855Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.91104 7.4268C4.69367 6.74822 4.68639 6.01979 4.89014 5.337C5.01234 4.80266 5.25883 4.30468 5.60959 3.88348C5.96035 3.46227 6.4055 3.12972 6.90889 2.91283C7.48317 2.62354 8.11064 2.45501 8.75257 2.41763C9.39451 2.38025 10.0373 2.47481 10.6413 2.69549C11.9913 3.29735 12.7771 4.78529 13.567 6.95033C13.6806 6.51231 13.9002 6.10897 14.2065 5.77586C14.4196 5.54306 14.7 5.38251 15.0087 5.31659C15.3173 5.25066 15.6388 5.28263 15.9285 5.40805C16.7644 5.75496 17.6672 6.66193 16.9149 8.38393C16.1625 10.1059 15.498 11.1425 15.5816 11.3096L16.2503 12.597L11.8617 14.6533L4.9194 7.44352L4.91104 7.4268Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.1646 17.1738C14.1646 17.1738 13.5126 15.6316 12.6265 13.9305C11.5064 11.7529 10.6663 9.58786 10.194 8.91495C9.67327 8.20086 8.9841 7.62655 8.18781 7.24311C7.68907 7.01669 7.14371 6.9119 6.59658 6.93733C6.04944 6.96276 5.51616 7.11769 5.04057 7.38939C4.46226 7.66981 3.94808 8.06661 3.53022 8.55494C3.11237 9.04328 2.79984 9.61263 2.61222 10.2273C2.28621 11.6609 3.01346 13.1865 4.26734 15.1049C3.8499 14.9318 3.3966 14.863 2.94659 14.9043C2.63223 14.9329 2.33467 15.059 2.09558 15.2652C1.8565 15.4713 1.68787 15.747 1.6133 16.0537C1.37506 16.9398 1.55478 18.1937 3.38545 18.6409C5.21611 19.0881 6.44492 19.1759 6.52851 19.3514C6.6121 19.527 7.15545 20.6596 7.15545 20.6596L14.1646 17.1738Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.09588 22.5778C8.09588 22.5778 11.5232 20.9435 12.8397 20.2205C13.3956 19.9153 15.1176 19.092 15.1176 19.092C15.2374 19.0311 15.3283 18.9253 15.3706 18.7978C15.4129 18.6702 15.4031 18.5311 15.3433 18.4107L14.8418 17.3992C14.7817 17.2797 14.6767 17.1889 14.5498 17.1466C14.4229 17.1043 14.2844 17.114 14.1647 17.1735C14.1647 17.1735 10.7081 18.9624 9.51695 19.4807C8.56818 19.8986 7.14293 20.6593 7.14293 20.6593C7.02239 20.7195 6.93055 20.8249 6.88748 20.9525C6.84441 21.0802 6.8536 21.2197 6.91306 21.3406L7.41461 22.3479C7.47477 22.4684 7.58018 22.5603 7.70783 22.6033C7.83548 22.6464 7.97499 22.6372 8.09588 22.5778V22.5778Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.73954 12.601C8.66431 12.4129 6.59959 10.3942 6.0437 9.67529Z" fill="#FFF9EA" />
                <path
                    d="M8.73954 12.601C8.66431 12.4129 6.59959 10.3942 6.0437 9.67529"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.12098 14.0221C8.12098 14.0221 5.98521 11.5143 4.73969 10.3398Z" fill="#FFF9EA" />
                <path
                    d="M8.12098 14.0221C8.12098 14.0221 5.98521 11.5143 4.73969 10.3398"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.55981 10.2314C7.91172 11.6019 7.18895 12.9358 6.39478 14.2271Z" fill="#FFF9EA" />
                <path
                    d="M8.55981 10.2314C7.91172 11.6019 7.18895 12.9358 6.39478 14.2271"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.35609 9.4541C6.80318 10.7785 6.09313 12.0316 5.24121 13.1865Z" fill="#FFF9EA" />
                <path
                    d="M7.35609 9.4541C6.80318 10.7785 6.09313 12.0316 5.24121 13.1865"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.0644 14.4905L10.265 16.0746C10.265 16.0746 10.8585 19.5687 10.9672 21.6753C11.0173 22.6993 11.4771 25.742 11.4771 25.742C11.4771 25.742 12.4008 27.3219 15.2387 27.7023C16.7763 27.9695 18.3441 28.0159 19.8948 27.8402C21.7848 27.6637 23.6191 27.1048 25.2865 26.1976C27.0837 25.3199 27.4014 23.9531 27.5895 23.6898C27.7232 23.5101 27.7023 21.3409 27.3387 18.9418C26.8371 15.7361 26.5822 11.9326 26.5822 11.9326"
                    fill="#FFF9EA"
                />
                <path
                    d="M10.0644 14.4905L10.265 16.0746C10.265 16.0746 10.8585 19.5687 10.9672 21.6753C11.0173 22.6993 11.4771 25.742 11.4771 25.742C11.4771 25.742 12.4008 27.3219 15.2387 27.7023C16.7763 27.9695 18.3441 28.0159 19.8948 27.8402C21.7848 27.6637 23.6191 27.1048 25.2865 26.1976C27.0837 25.3199 27.4014 23.9531 27.5895 23.6898C27.7232 23.5101 27.7023 21.3409 27.3387 18.9418C26.8371 15.7361 26.5822 11.9326 26.5822 11.9326"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M26.5822 11.9325C26.6951 12.9356 25.8341 13.9512 24.3545 14.7746C22.8749 15.598 20.8604 16.0661 18.5992 16.4464C17.0736 16.6775 15.5204 16.6563 14.0016 16.3837C12.079 16.0786 10.6287 15.4099 10.0603 14.4987C9.92384 14.2871 9.83802 14.0468 9.80951 13.7966C9.67158 12.5427 11.0341 11.3682 13.1532 10.4153C14.6273 9.78512 16.1943 9.39971 17.7925 9.27424C19.1821 9.13255 20.5826 9.13255 21.9721 9.27424C24.7683 9.5083 26.4192 10.5699 26.5822 11.9325Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.7443 15.0672C24.3838 14.7997 20.9356 13.5291 17.4373 14.085C13.9389 14.6409 13.2786 16.2375 13.2786 16.2375C13.2786 16.2375 15.9201 16.5844 16.9232 16.5969C19.2735 16.5257 21.5886 16.0065 23.7443 15.0672V15.0672Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.49317 15.4915L7.5492 15.7086C7.17756 15.7501 6.90992 16.085 6.9514 16.4566L7.00102 16.9011C7.04251 17.2727 7.37742 17.5403 7.74906 17.4989L9.69304 17.2818C10.0647 17.2403 10.3323 16.9054 10.2908 16.5338L10.2412 16.0893C10.1997 15.7177 9.86482 15.4501 9.49317 15.4915Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M29.3864 13.2694L27.4424 13.4864C27.0708 13.5279 26.8032 13.8628 26.8447 14.2344L26.8943 14.6789C26.9358 15.0505 27.2707 15.3182 27.6423 15.2767L29.5863 15.0597C29.9579 15.0182 30.2256 14.6833 30.1841 14.3116L30.1345 13.8672C30.093 13.4955 29.7581 13.2279 29.3864 13.2694Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11321">
                    <rect width="30" height="30" fill="white" transform="translate(0.894531 0.176758)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMHouseholdInactive;

MMHouseholdInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMHouseholdInactive.defaultProps = {
    className: null,
    width: 28,
};
